import { CARD_SORT_OPTIONS, CARD_SORT_BY_COST, CARD_SORT_DIR_DESC } from '../utils/sorcery/cardSort';
import { GOLD } from '../lib/medievalTheme';
import { t } from '../localization/t';

// Name / Cost sort chips shared by the deck editor collection and the draft
// pool. Only the Cost chip carries a direction arrow: Name is always A→Z, so
// an arrow would imply it can flip. The arrow slot is always rendered (faded
// when inactive) so the chip keeps one width and its neighbors never shift.
export default function CardSortChips({ sortBy, sortDir, onSelect }) {
  return (
    <div className="flex items-center gap-0.5" aria-label={t('Sort cards by')}>
      <span className="text-[0.625cqw] mr-1.5" style={{ color: `${GOLD} 0.45)` }}>{t('Sort')}</span>
      {CARD_SORT_OPTIONS.map((opt) => {
        const active = sortBy === opt.value;
        const isCost = opt.value === CARD_SORT_BY_COST;
        return (
          <button
            key={opt.value}
            type="button"
            className="filter-chip"
            data-active={active ? 'true' : 'false'}
            aria-label={
              active && isCost
                ? (sortDir === CARD_SORT_DIR_DESC ? t('Sorted by Cost descending; click to reverse') : t('Sorted by Cost ascending; click to reverse'))
                : t('Sort by {label}', { label: t(opt.label) })
            }
            aria-pressed={active}
            onClick={() => onSelect(opt.value)}
          >
            {t(opt.label)}
            {isCost ? (
              <span
                aria-hidden="true"
                className="inline-block transition-opacity duration-100"
                style={{ marginLeft: '0.2cqw', opacity: active ? 1 : 0 }}
              >
                {sortDir === CARD_SORT_DIR_DESC ? '↓' : '↑'}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
